import React from "react";
import { Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import BlogDetailPage from "./pages/BlogDetailPage";
import OrderPage from "./pages/OrderPage";

// Placeholder pages — replace with real components as you build them
const PlaceholderPage = ({ title }) => (
  <div className="min-h-screen bg-[#0a1a0f] flex items-center justify-center">
    <h1 className="text-white text-3xl font-light tracking-widest uppercase">
      {title}
    </h1>
  </div>
);

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/blog/:slug" element={<BlogDetailPage />} />
      <Route path="/order" element={<OrderPage />} />
      <Route path="/about" element={<PlaceholderPage title="About Us" />} />
      <Route path="/menu" element={<PlaceholderPage title="Menu" />} />
      <Route path="/pages" element={<PlaceholderPage title="Pages" />} />
      <Route path="/blog" element={<PlaceholderPage title="Blog" />} />
      <Route path="/contact" element={<PlaceholderPage title="Contact Us" />} />
      <Route
        path="/privacy"
        element={<PlaceholderPage title="Privacy Policy" />}
      />
      <Route
        path="/terms"
        element={<PlaceholderPage title="Terms & Services" />}
      />
      {/* 404 fallback */}
      <Route
        path="*"
        element={<PlaceholderPage title="404 — Page Not Found" />}
      />
    </Routes>
  );
};

export default AppRoutes;
